import {memo} from 'react'

import {DeliveryType} from 'src/shared/types'

import {useFetchOrderAvailability} from './hooks/use-fetch-order-availability'
import {SubmitButtonNdd} from './SubmitButtonNdd/SubmitButtonNdd'
import {SubmitButtonOffers} from './SubmitButtonOffers/SubmitButtonOffers'
import type {Props} from './types'

export const SubmitButton = memo<Props>(function SubmitButton(props) {
  const {isOrderAvailabilityPending} = useFetchOrderAvailability()

  switch (props.rawVertical) {
    case DeliveryType.NDD_Self_Pickup:
    case DeliveryType.NDD_Shipment:
      return <SubmitButtonNdd {...props} isLoading={isOrderAvailabilityPending} />
    default:
      return <SubmitButtonOffers {...props} isLoading={isOrderAvailabilityPending} />
  }
})
